export const LoanActionType = {
    SEND_PROPOSAL: 'loan/SEND_PROPOSAL',
}